/** Lỗi hết hạn mức Firestore (gói miễn phí: 50.000 lượt đọc / 20.000 lượt ghi mỗi ngày). */
export const isQuotaError = (e: unknown): boolean => {
  const x = e as { code?: unknown; message?: unknown } | null;
  return /quota|resource-exhausted|resource_exhausted/i.test(`${x?.code ?? ''} ${x?.message ?? ''}`);
};

export const QUOTA_MESSAGE =
  'Firebase đã hết hạn mức đọc/ghi miễn phí trong ngày nên chưa lưu được. Chưa có gì bị thay đổi. ' +
  'Hạn mức tự đặt lại khoảng 14:00 (giờ Việt Nam, 15:00 từ 1/11); hoặc nâng dự án lên gói Blaze để bỏ giới hạn.';
